// extracted by mini-css-extract-plugin
export default {"startApp":"StartApplicationPage_startApp__QP54k","h1":"StartApplicationPage_h1__7wXi+"};